<template>
  <page>
    <div :load="doInit">
          <form>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <!-- <v-card-title>
                <div class="body-2">Date Ranges</div>
              </v-card-title> -->
              <!-- <v-divider class="mt-3 mb-3"></v-divider>
              <v-card-title>
                <div class="body-2">Filters</div>
              </v-card-title> -->
              <v-expansion-panels v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="reportForm.polType"
                                :label="labels.polType"
                                :error-messages="errors.collect('polType')"
                                :data-vv-as="labels.polType"
                                data-vv-name="polType"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('polType')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                              v-model="reportForm.branch"
                              :label="labels.branch"
                              :error-messages="errors.collect('form.branch')"
                              :data-vv-as="labels.branch"
                              v-validate="'required'"
                              data-vv-name="reportForm.branch"
                              append-icon="mdi-magnify"
                              @click:append="doHelplist('branch')"
                              readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs7>
                              <v-select v-model="reportForm.yrType" :items="yrTypeList" :label="labels.yrType" item-text="label" item-value="value" />
                            </v-flex>
                            <v-flex xs6 sm6 md6 lg6>
                              <v-select v-model="reportForm.yrFrom"
                                        :items="yrFromList"
                                        :label="labels.yrFrom"
                                        item-text="label"
                                        item-value="value"
                                        v-validate="'required|afterYrFrom'"
                                        data-vv-name="reportForm.yrFrom"
                                        :error-messages="errors.collect('yrFrom')" />
                            </v-flex>
                            <v-flex xs6 sm6 md6 lg6>
                              <v-select v-model="reportForm.yrTo"
                                        :items="yrToList"
                                        :label="labels.yrTo"
                                        item-text="label"
                                        item-value="value"
                                        v-validate="'required|afterYrFrom'"
                                        :data-vv-as="labels.yrTo"
                                        data-vv-name="yrTo"
                                        :error-messages="errors.collect('yrTo')" />
                            </v-flex>
                            <v-flex xs7>
                              <v-select v-model="reportForm.rptType" :items="reportTypeList" :label="labels.rptType" item-text="label" item-value="value" />
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
            </v-container>
          </form>
      <v-container fluid grid-list-md>
                                <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg12>
                  <v-checkbox
                    :label="labels.pbPrtParam"
                    v-model="reportForm.pbPrtParam"
                    :error-messages="errors.collect('pbPrtParam')"
                    data-vv-name="pbPrtParam"
                    :data-vv-as="labels.pbPrtParam"
                  />
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    Export To
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="reportForm.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
      </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="reportForm.branch" @close="showBranchHelpList = false" @doAssign="doAssign($event)"></multi-branch-help-list>
    </v-dialog>
      <v-dialog v-model="multiPolTypeHelpList" width="900px" persistent>
        <multi-pol-type-help-list v-show="multiPolTypeHelpList" :pt="reportForm.polType" @close="doCloseHelpList" @doAssign="doAssign($event)"></multi-pol-type-help-list>
        <!-- clone a new array and pass it to child to prevent the array in parent from mutated by child without being aware of it -->
      </v-dialog>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
export default {
  data() {
    return {
      labels: {
        polType: 'Policy Type(s)',
        branch: 'Branch(es)',
        rptParam: 'Print report runtime parameters',
        yrType: 'Year Type',
        yrFrom: 'Year From',
        yrTo: 'Year To',
        rptType: 'Report Type',
        pbPrtParam: 'Print Runtime Parameters'
      },
      yrTypeList: [
        { label: 'Claim Year', value: 'clmYr' },
        { label: 'Loss Year', value: 'loYr' },
        { label: 'Underwriting Year', value: 'uwYr' }
      ],
      yrFromList: [],
      yrToList: [],
      reportTypeList: [
        { label: 'Gross', value: 'gross' },
        { label: 'Net', value: 'net' }
      ],
      reportForm: {
        polType: 'All',
        branch: 'All',
        yrType: 'clmYr',
        yrFrom: null,
        yrTo: null,
        rptType: 'gross',
        rptParam: null,
        format: null,
        pbPrtParam: true
      },
      supportedFormat: [],
      menu: {},
      submitting: false,
      helplist: false,
      showBranchHelpList: false,
      multiPolTypeHelpList: false,
      rptHistory: false,
      yrToError: false,
      panel1: [0],
      panel2: [0],
      panel4: [0]
    }
  },
  created() {
    this.doInit()
  },
  mounted() {
    this.generateYearList()
    this.$validator.extend('afterYrFrom', {
      getMessage: field => `The ${field} must be after Year From.`,
      validate: value => {
        const yrFrom = this.reportForm.yrFrom
        return value >= yrFrom
      }
    })
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
      const apiURI = this.rptMenu.initLadderStats
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
            this.reportForm.polType = 'All'
            this.reportForm.branch = 'All'
            this.reportForm.yrType = 'clmYr'
            this.reportForm.yrFrom = new Date().getFullYear()
            this.reportForm.yrTo = new Date().getFullYear()
            this.reportForm.rptType = 'gross'
            this.reportForm.rptParam = false
          }
        } catch (err) {
          throw err
        }
      }
    },
    generateYearList() {
      const currentYear = new Date().getFullYear()
      for (let i = currentYear; i > currentYear - 15; i--) {
        this.yrFromList.push({ label: i.toString(), value: i })
        this.yrToList.push({ label: i.toString(), value: i })
      }
    },
    doExport() {
      try {
        if (this.reportForm.yrFrom >= this.reportForm.yrTo) {

        }
      } catch (err) {
        this.submitting = false
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportDetail
      if (apiURI) {
        this.submitting = true
        try {
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doHelplist(field) {
      this.helplist = true
      switch (field) {
        case 'branch': {
          this.showBranchHelpList = true
          break
        }
        case 'polType': {
          this.multiPolTypeHelpList = true
          break
        }
        default: {
          this.helplist = false
          this.multiPolTypeHelpList = false
          this.showBranchHelpList = false
          break
        }
      }
    },
    doAssign(data) {
      if (this.multiPolTypeHelpList) {
        this.reportForm.polType = []
        this.reportForm.polType = data.finalSelectedItems.toString()
      }
      if (this.showBranchHelpList) {
        this.reportForm.branch = []
        this.reportForm.branch = data.finalSelectedItems.toString()
      }
    },
    processRptKey(rptKey) {
      this.resetMessages()
      // For the Report Job History only
      JSON.parse(rptKey, (key, value) => {
        switch (key) {
          case 'polType': {
            this.reportForm.polType = value
            break
          }
          case 'branch': {
            this.reportForm.branch = value
            break
          }
          case 'rptParam': {
            this.reportForm.rptParam = value
            break
          }
          case 'format': {
            this.reportForm.format = value
            break
          }
          default: {
            break
          }
        }
      })
    },
    doClose(rptKey) {
      if (rptKey !== undefined && rptKey !== null) {
        this.processRptKey(rptKey)
      }
      this.helplist = false
      this.rptHistory = false
    },
    doCloseHelpList(rptKey) {
      this.helplist = false
      this.multiPolTypeHelpList = false
      this.showBranchHelpList = false
    },
    formatBoolean(xBoolean) {
      return xBoolean ? 'Yes' : 'No'
    },
    clone(arr) {
      return clone(arr)
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList(value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  components: {
    MultiPolTypeHelpList,
    MultiBranchHelpList
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style></style>
